"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneVerifyContext = void 0;
var _react = require("react");
var _EPhoneVerificationStatus = _interopRequireDefault(require("../enums/EPhoneVerificationStatus"));
var stub = function stub() {
  throw new Error('<PhoneVerifyProvider> not found.');
};
var PhoneVerifyContext = (0, _react.createContext)({
  phoneVerificationStatus: _EPhoneVerificationStatus.default.Initial,
  verifyPhone: stub,
  checkSmsCode: stub
});
exports.PhoneVerifyContext = PhoneVerifyContext;
PhoneVerifyContext.displayName = 'PhoneVerifyContext';